import React from 'react';
import AIPPT from '../../PageComponents/AIPPT';

/**
 * AIPPT 容器组件
 * 封装了 AIPPT 组件的所有 props 传递逻辑
 */
const AIPPTContainer = ({
    skillStore,
    checkIsLogin,
    sessionId,
    curSkill,
    setCurSkill,
    sessionMap,
    currentAgent,
    loading,
    content,
    setContent,
    skillList,
    curPlugin,
    setCurPlugin,
    submitMsg,
    skillPreQuestion,
    clickGuide,
    agentFile,
    setAgentFile,
    agentFileRef,
    style,
    editPlanMode,
    toggleEditPlanMode,
    resetEditPlanMode,
    isInputVisible,
    showTTSComponent,
    showChatInterface,
    onTTSToggle,
    stopDeerFlow,
    generatingReports,
    sidebarOpen,
    activeReportId,
    handleStartNewMsg,
    sessionStatus,
    agentId,
    getHistorySessionList,
    linkToSession,
    formatSessionList,
    sessionListRef,
    handleMessages,
    changeSessionMapItem,
    changeOriginMsgMapRef,
    originMsgMapRef,
    handleAIPPTHistoryMessage,
    handleGetSessionMessage
}) => {
    return (
        <AIPPT
            skillStore={skillStore}
            checkIsLogin={checkIsLogin}
            conversationId={sessionId}
            skillId={curSkill?.id}
            curSkill={curSkill}
            setCurSkill={setCurSkill}
            // 传递聊天相关的props
            sessionMap={sessionMap}
            currentAgent={currentAgent}
            sessionId={sessionId}
            loading={loading}
            content={content}
            setContent={setContent}
            skillList={skillList}
            curPlugin={curPlugin}
            setCurPlugin={setCurPlugin}
            submitMsg={submitMsg}
            skillPreQuestion={skillPreQuestion}
            clickGuide={clickGuide}
            agentFile={agentFile}
            setAgentFile={setAgentFile}
            agentFileRef={agentFileRef}
            style={style}
            editPlanMode={editPlanMode}
            toggleEditPlanMode={toggleEditPlanMode}
            resetEditPlanMode={resetEditPlanMode}
            isInputVisible={isInputVisible}
            showTTSComponent={showTTSComponent}
            showChatInterface={showChatInterface}
            onTTSToggle={onTTSToggle}
            stopDeerFlow={stopDeerFlow}
            generatingReports={generatingReports}
            sidebarOpen={sidebarOpen}
            activeReportId={activeReportId}
            handleStartNewMsg={handleStartNewMsg}
            sessionStatus={sessionStatus}
            agentId={agentId}
            // 🔥 新增：传递会话列表更新函数
            getHistorySessionList={getHistorySessionList}
            // 🔥 新增：传递导航函数
            linkToSession={linkToSession}
            // 🔥 新增：传递会话列表相关函数和引用
            formatSessionList={formatSessionList}
            sessionListRef={sessionListRef}
            // 🔥 新增：传递消息处理函数
            handleMessages={handleMessages}
            // 🔥 新增：会话映射操作函数
            changeSessionMapItem={changeSessionMapItem}
            // 🔥 新增：原始消息映射操作函数
            changeOriginMsgMapRef={changeOriginMsgMapRef}
            // 🔥 新增：原始消息映射引用
            originMsgMapRef={originMsgMapRef}
            // 🔥 新增：AIPPT历史消息处理函数
            handleAIPPTHistoryMessage={handleAIPPTHistoryMessage}
            // 🔥 新增：获取会话消息函数
            handleGetSessionMessage={handleGetSessionMessage}
        />
    );
};

export default AIPPTContainer;
